import React from 'react';

/**
 * Card metrica con valore grande, label e sottotitolo opzionale.
 *
 * @param {string|number} value  — valore principale (grande, bold)
 * @param {string}        label  — etichetta sotto il valore
 * @param {string}        sub    — testo secondario (colore accent, opzionale)
 * @param {ReactNode}     icon   — icona opzionale in alto a destra
 */
function StatCard({ value, label, sub, icon }) {
  return (
    <div style={{
      background:   'var(--bg-card)',
      border:       '1px solid var(--color-border)',
      borderRadius: 'var(--radius-lg)',
      padding:      '20px 24px',
      flex:         1,
      minWidth:     0,
      position:     'relative',
    }}>
      {icon && (
        <div style={{ position: 'absolute', top: 16, right: 16, opacity: 0.4, fontSize: 18 }}>
          {icon}
        </div>
      )}
      <div style={{
        fontSize:      'var(--text-3xl)',
        fontWeight:    'var(--font-black)',
        color:         'var(--color-text)',
        letterSpacing: -1,
        lineHeight:    'var(--leading-none)',
      }}>
        {value}
      </div>
      <div style={{
        fontSize:   'var(--text-sm)',
        color:      'var(--color-text-dim)',
        marginTop:  'var(--space-1)',
      }}>
        {label}
      </div>
      {sub && (
        <div style={{
          fontSize:  'var(--text-xs)',
          color:     'var(--accent)',
          marginTop: 2,
        }}>
          {sub}
        </div>
      )}
    </div>
  );
}

export default StatCard;
